import '../../assets/index45.css';var q = Object.defineProperty, D = Object.defineProperties;
var K = Object.getOwnPropertyDescriptors;
var g = Object.getOwnPropertySymbols;
var N = Object.prototype.hasOwnProperty, z = Object.prototype.propertyIsEnumerable;
var S = (r, o, t) => o in r ? q(r, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : r[o] = t, l = (r, o) => {
  for (var t in o || (o = {}))
    N.call(o, t) && S(r, t, o[t]);
  if (g)
    for (var t of g(o))
      z.call(o, t) && S(r, t, o[t]);
  return r;
}, p = (r, o) => D(r, K(o));
var C = (r, o) => {
  var t = {};
  for (var e in r)
    N.call(r, e) && o.indexOf(e) < 0 && (t[e] = r[e]);
  if (r != null && g)
    for (var e of g(r))
      o.indexOf(e) < 0 && z.call(r, e) && (t[e] = r[e]);
  return t;
};
import { jsx as n } from "react/jsx-runtime";
import { useContext as T, createContext as V, useState as H, useEffect as J, forwardRef as L } from "react";
import { UserCircleFarFAIcon as O } from "../Icons/index.js";
import { r as Q } from "../../rem-CMQJ_ZTp.js";
import { b as W, e as X, c as Y } from "../../get-size-Bc1Pz5yf.js";
import { c as M } from "../../create-vars-resolver-Bzbn9G-G.js";
import { f as rr, u as I, B as Z } from "../../factory-ueRxoNOV.js";
import { u as E } from "../../use-styles-DToiHEa6.js";
import { p as or } from "../../polymorphic-factory-DufevJAl.js";
const P = V(null), tr = P.Provider;
function er() {
  return { withinGroup: !!T(P) };
}
var h = { group: "m_11def92b", root: "m_f85678b6", image: "m_11f8ac07", placeholder: "m_104cd71f" };
const ar = {}, sr = M((r, { spacing: o }) => ({
  group: {
    "--ag-spacing": W(o)
  }
})), A = rr((r, o) => {
  const t = I("AvatarGroup", ar, r), y = t, { classNames: e, className: c, style: i, styles: u, unstyled: d, vars: v, spacing: a } = y, s = C(y, ["classNames", "className", "style", "styles", "unstyled", "vars", "spacing"]), _ = E({
    name: "AvatarGroup",
    classes: h,
    props: t,
    className: c,
    style: i,
    classNames: e,
    styles: u,
    unstyled: d,
    vars: v,
    varsResolver: sr,
    rootSelector: "group"
  });
  return /* @__PURE__ */ n(tr, { value: !0, children: /* @__PURE__ */ n(Z, l(l({ ref: o }, _("group")), s)) });
});
A.classes = h;
A.displayName = "@mantine/core/AvatarGroup";
function lr(r) {
  return /* @__PURE__ */ n(
    "svg",
    p(l({}, r), {
      "data-avatar-placeholder-icon": !0,
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ n(
        "path",
        {
          d: "M0.877014 7.49988C0.877014 3.84219 3.84216 0.877045 7.49985 0.877045C11.1575 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1575 14.1227 7.49985 14.1227C3.84216 14.1227 0.877014 11.1575 0.877014 7.49988ZM7.49985 1.82704C4.36683 1.82704 1.82701 4.36686 1.82701 7.49988C1.82701 8.97196 2.38774 10.3131 3.30727 11.3213C4.19074 9.94119 5.73818 9.02499 7.50023 9.02499C9.26206 9.02499 10.8093 9.94097 11.6929 11.3208C12.6121 10.3127 13.1727 8.97172 13.1727 7.49988C13.1727 4.36686 10.6328 1.82704 7.49985 1.82704ZM10.9818 11.9787C10.2839 10.7795 8.9857 9.97499 7.50023 9.97499C6.01458 9.97499 4.71624 10.7797 4.01845 11.9791C4.97952 12.7272 6.18765 13.1727 7.49985 13.1727C8.81227 13.1727 10.0206 12.727 10.9818 11.9787ZM5.14999 6.50487C5.14999 5.207 6.20212 4.15487 7.49999 4.15487C8.79786 4.15487 9.84999 5.207 9.84999 6.50487C9.84999 7.80274 8.79786 8.85487 7.49999 8.85487C6.20212 8.85487 5.14999 7.80274 5.14999 6.50487ZM7.49999 5.10487C6.72679 5.10487 6.09999 5.73167 6.09999 6.50487C6.09999 7.27807 6.72679 7.90487 7.49999 7.90487C8.27319 7.90487 8.89999 7.27807 8.89999 6.50487C8.89999 5.73167 8.27319 5.10487 7.49999 5.10487Z",
          fill: "currentColor",
          fillRule: "evenodd",
          clipRule: "evenodd"
        }
      )
    })
  );
}
function nr(r) {
  let o = 0;
  for (let t = 0; t < r.length; t += 1) {
    const e = r.charCodeAt(t);
    o = (o << 5) - o + e, o |= 0;
  }
  return o;
}
const cr = [
  "blue",
  "cyan",
  "grape",
  "green",
  "indigo",
  "lime",
  "orange",
  "pink",
  "red",
  "teal",
  "violet"
];
function ir(r, o = cr) {
  const t = nr(r), e = Math.abs(t) % o.length;
  return o[e];
}
function dr(r, o = 2) {
  const t = r.split(" ");
  return t.length === 1 ? r.slice(0, o).toUpperCase() : t.map((e) => e[0]).slice(0, o).join("").toUpperCase();
}
const ur = {}, pr = M(
  (r, { size: o, radius: t, variant: e, gradient: c, color: i, autoContrast: u, name: d, allowedInitialsColors: v }) => {
    const a = i === "initials" && typeof d == "string" ? ir(d, v) : i, s = r.variantColorResolver({
      color: a || "gray",
      theme: r,
      gradient: c,
      variant: e || "light",
      autoContrast: u
    });
    return {
      root: {
        "--avatar-size": Y(o, "avatar-size"),
        "--avatar-radius": t === void 0 ? void 0 : X(t),
        "--avatar-bg": a || e ? s.background : void 0,
        "--avatar-color": a || e ? s.color : void 0,
        "--avatar-bd": a || e ? s.border : void 0
      }
    };
  }
), f = or((r, o) => {
  const t = I("Avatar", ur, r), b = t, {
    classNames: e,
    className: c,
    style: i,
    styles: u,
    unstyled: d,
    vars: v,
    src: a,
    alt: s,
    radius: _,
    color: y,
    gradient: yr,
    imageProps: m,
    children: U,
    autoContrast: xr,
    mod: $,
    name: w,
    allowedInitialsColors: Ar
  } = b, B = C(b, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "vars",
    "src",
    "alt",
    "radius",
    "color",
    "gradient",
    "imageProps",
    "children",
    "autoContrast",
    "mod",
    "name",
    "allowedInitialsColors"
  ]), F = er(), [j, G] = H(!a), x = E({
    name: "Avatar",
    props: t,
    classes: h,
    className: c,
    style: i,
    classNames: e,
    styles: u,
    unstyled: d,
    vars: v,
    varsResolver: pr
  });
  return J(() => G(!a), [a]), /* @__PURE__ */ n(
    Z,
    p(l(p(l({}, x("root")), {
      mod: [{ "within-group": F.withinGroup }, $],
      ref: o
    }), B), {
      children: j ? /* @__PURE__ */ n("span", p(l({}, x("placeholder")), { title: s, children: U || typeof w == "string" && dr(w) || /* @__PURE__ */ n(lr, {}) })) : /* @__PURE__ */ n(
        "img",
        p(l(l({}, m), x("image")), {
          src: a,
          alt: s,
          onError: (k) => {
            var R;
            G(!0), (R = m == null ? void 0 : m.onError) == null || R.call(m, k);
          }
        })
      )
    })
  );
});
f.classes = h;
f.displayName = "@mantine/core/Avatar";
f.Group = A;
const vr = "Avatar-module__root___czD7U", mr = "Avatar-module__placeholder___gKw6q", gr = {
  root: vr,
  placeholder: mr
}, Cr = {
  xs: 16,
  sm: 32,
  md: 48,
  lg: 64,
  xl: 88
}, hr = {
  xs: 8,
  sm: 14,
  md: 20,
  lg: 24,
  xl: 40
}, fr = L((v, d) => {
  var a = v, {
    className: r,
    src: o,
    alt: t,
    children: e,
    size: c = "md",
    variant: i = "default"
  } = a, u = C(a, [
    "className",
    "src",
    "alt",
    "children",
    "size",
    "variant"
  ]);
  const s = Q(hr[c]);
  return /* @__PURE__ */ n(
    f,
    p(l({
      className: r,
      classNames: gr,
      ref: d,
      src: o,
      alt: t,
      radius: "100%",
      size: Cr[c],
      mod: { size: c, variant: i }
    }, u), {
      children: e || /* @__PURE__ */ n(O, { style: { width: s, height: s } })
    })
  );
});
fr.displayName = "Avatar";
export {
  fr as Avatar
};
